<template>
  <div class="relative bg-white-200 min-h-screen flex" dir="ltr">
    <CSidebar />

    <div
      class="w-full h-full flex-shrink max-w-[1280px] mx-auto p-3 sm:px-10 sm:pb-10 md:pt-0 pb-[76px]"
    >
      <CHeader v-if="isDesktop" />
      <CMobileHeader v-if="isMobile" />
      <MobileNavigation v-if="isMobile" />
      <div
        class="relative h-full w-full z-0"
        :class="{
          'max-w-[782px] box-content': location === '/privacy-policy',
        }"
      >
        <div class="w-full h-full exchange-height">
          <slot />
        </div>
      </div>
    </div>
    <NotificationDialog
      @close="closeNotification"
      :show="notificationStore.showNotificationDetail"
    />
    <UserWalletWarning :show="showWalletWarning" @close="closeWalletWarning" />
    <COnboardingVideoDialog
      :show="showOnboardingVideo"
      video-url="https://youtu.be/G5vLRytOwjc?si=5skOD-BNopRCuFdU"
      :title="$t('onboarding.welcome_to_dashboard')"
      :description="$t('onboarding.watch_this_quick_tutorial')"
      :close-button-text="$t('onboarding.got_it')"
      @close="handleOnboardingClose"
    />
  </div>
</template>
<script lang="ts" setup>
import MobileNavigation from "@/components/Mobile/Navigation.vue";
import { useMobile } from "@/composables/useMobile";
import CSidebar from "@/layout/Dashboard/components/CSidebar.vue";
import CHeader from "@/layout/Dashboard/components/CHeader.vue";
import CMobileHeader from "@/components/Mobile/CHeader.vue";
import { computed, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { useCommonStore } from "@/modules/Pages/stores";
import { useNotificationStore } from "@/modules/Notification/stores";
import NotificationDialog from "@/modules/Notification/components/NotificationDialog.vue";
import UserWalletWarning from "@/layout/Dashboard/components/userWalletWarning.vue";
import { useBotStore } from "@/modules/Bots/stores";
import COnboardingVideoDialog from "@/components/Common/COnboardingVideoDialog.vue";
import { useI18n } from "vue-i18n";

const route = useRoute();
const { isMobile } = useMobile("mobile");
const { isDesktop } = useMobile("desktop");
const { t } = useI18n();

const botStore = useBotStore();
const commonStore = useCommonStore();
const notificationStore = useNotificationStore();
const showOnboardingVideo = ref(false);

const showWalletWarning = computed(() => botStore.showWalletWarning);
const location = computed(() => route.path);

const closeWalletWarning = () => {
  botStore.showWalletWarning = false;
};

const closeNotification = () => {
  notificationStore.showNotificationDetail = false;
  // if (!notificationSingle.value?.is_read) {
  notificationStore.getHeaderNotifications({
    size: notificationStore.size.page,
  });
  notificationStore.getNotifications({
    size: notificationStore.size.page,
  });
  // }
};

const handleOnboardingClose = () => {
  showOnboardingVideo.value = false;
  localStorage.setItem("has_seen_dashboard_onboarding", "true");
};

onMounted(() => {
  // Show onboarding video if user hasn't seen it before
  const hasSeenOnboarding = localStorage.getItem(
    "has_seen_dashboard_onboarding",
  );
  if (!hasSeenOnboarding) {
    setTimeout(() => {
      showOnboardingVideo.value = true;
    }, 500);
  }

  commonStore.fetchStaticPages();
  notificationStore.getHeaderNotifications({ size: 5 });
});
</script>
<style>
.exchange-height {
  min-height: calc(100vh - 110px);
}
</style>
